import { PatientConsult } from 'api/consult/types/consults.types';
import axiosInstance from 'helpers/axiosInstance';

interface UpdatePatientConsultStateResponse {
  patientConsult: PatientConsult;
}

interface SharedParams {
  id: string;
}

export type PatientMachineTransitions =
  | 'start_assessment'
  | 'complete_assessment'
  | 'fail_assessment';

interface PatientMachineParams extends SharedParams {
  machine: 'patient';
  event: PatientMachineTransitions;
}

export type PaymentMachineTransitions = 'decline' | 'complete_payment';

interface PaymentMachineParams extends SharedParams {
  machine: 'payment';
  event: PaymentMachineTransitions;
}

export type UpdatePatientConsultStateParams =
  | PatientMachineParams
  | PaymentMachineParams;

export const updatePatientConsultState = (
  vars: UpdatePatientConsultStateParams,
) => {
  const url = `/patients/patient_consults/${vars.id}/${vars.machine}/${vars.event}`;
  return axiosInstance
    .patch<UpdatePatientConsultStateResponse>(url)
    .then(r => r.data.patientConsult);
};
